














































import { Component, Vue } from "vue-property-decorator";
import { AuthApi } from "@/services/api-service";
import { LoginBody } from "@/api/api";
import AuthModule from "@/store/auth";
import TokenUtil from "@/utils/TokenUtil";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";

@Component({
  components: {
    CTooltip,
  },
})
export default class CLoginForm extends Vue {
  private isStoreLogin = false;

  private form: LoginBody = {
    email: "",
    password: "",
  };

  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private async submit() {
    try {
      const loginRes = await AuthApi.instance.userLogin(this.form);
      if (!loginRes.data.data?.user || !loginRes.data.data?.token) {
        return;
      }
      AuthModule.commitMe(loginRes.data.data.user);
      TokenUtil.setToken(loginRes.data.data.token, this.isStoreLogin);

      this.$router.push({ name: "CUserProfile" });
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      console.log(err);
    }
  }
}
